export default "__VITE_ASSET__5995a634__"